export const generateId = async (prefix, cntryCode, module) => {
  let id = "XXXX";
  let output = "";
  const year = new Date().getFullYear().toString().substring(2, 4);
  if (module) {
    try {
      output = `${prefix}${cntryCode}${year}-${id}`;
    } catch (e) {
      id = "";
      output = "";
    }
  }
  return output;
};
